import axios from 'axios';

// Global handler for permission errors
export let globalPermissionErrorHandler = null;
export const setGlobalPermissionErrorHandler = (handler) => {
  globalPermissionErrorHandler = handler;
};

//const API_BASE_URL = 'http://localhost:9091/api';

const API_BASE_URL = '/api';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
  const token = sessionStorage.getItem('agentToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isAuthError = error.response?.status === 401 || error.response?.status === 403;
    const isJwtExpired = error.response?.data?.message?.includes('JWT expired') ||
      (typeof error.response?.data === 'string' && error.response.data.includes('JWT expired'));
    if (isAuthError || isJwtExpired) {
      sessionStorage.removeItem('agentToken');
      window.location.href = '/agent/login';
      return; // Prevent further error handling
    }
    return Promise.reject(error);
  }
);

export { api };
